import React, { useEffect, useImperativeHandle, useRef, useState, useContext } from 'react'
import { Select, message, Spin, InputNumber, Table, Form } from 'antd'
import type { GetRef, InputRef } from 'antd';
import { SGeneralForms, SModalSelected } from 'shj-components'
import { finAccountList } from "@/services/fmsConfig";
import { httpDictServTenant, getEnum } from "@/services/fmsServices";
import dayjs from 'dayjs'
import styles from '../index.module.less'

// 表格编辑

type FormInstance<T> = GetRef<typeof Form<T>>;

const EditableContext = React.createContext<FormInstance<any> | null>(null);

interface EditableRowProps {
  index: number;
}

const EditableRow: React.FC<EditableRowProps> = ({ index, ...props }) => {
  const [form] = Form.useForm();
  return (
    <Form form={form} component={false}>
      <EditableContext.Provider value={form}>
        <tr {...props} />
      </EditableContext.Provider>
    </Form>
  );
};

interface EditableCellProps {
  title: React.ReactNode;
  editable: boolean;
  dataIndex: any;
  record: any;
  handleSave: (record: any) => void;
  errSave: (record: any) => void;
}

const EditableCell: React.FC<React.PropsWithChildren<EditableCellProps>> = ({
  title,
  editable,
  children,
  dataIndex,
  record,
  handleSave,
  errSave,
  ...restProps
}) => {
  const [editing, setEditing] = useState(false);
  const inputRef = useRef<InputRef>(null);
  const form = useContext(EditableContext)!;

  useEffect(() => {
    if (editing) {
      inputRef.current?.focus();
    }
  }, [editing]);

  const toggleEdit = () => {
    setEditing(!editing);
    form.setFieldsValue({ [dataIndex]: record[dataIndex] });
  };

  const save = async () => {
    try {
      const values = await form.validateFields();
      toggleEdit();
      handleSave({ ...record, ...values });
      errSave(null); 
    } catch (errInfo:any) {
      // 将 errInfo 通过 getValue 传递
      errSave(errInfo.errorFields);
    }
  };
  let childNode = children;

  if (editable) {
    childNode = editing ? (
      <Form.Item
        style={{ margin: 0 }}
        name={dataIndex}
        rules={[
          { required: true, message: `不能为空` },
          {
            validator: (_, value) => {
              if (value > record.unverifiedAmount) {
                return Promise.reject(new Error(`不能大于未核销金额`));
              }
              return Promise.resolve();
            }
          }
        ]}
      >
        <InputNumber ref={inputRef} onPressEnter={save} onBlur={save} />
      </Form.Item>
    ) : (
      <div
        className={styles.editableCellValueWrap}
        style={{ paddingInlineEnd: 24 }}
        onClick={toggleEdit}
      >
        {children}
      </div>
    );
  }

  return <td {...restProps}>{childNode}</td>;
};
export const CollectionForm = React.forwardRef((props: any, ref) => {






  const { collectData, collectList = [], financialOrgCode } = props
  const formRef: any = useRef()
  const [spinning, setSpinning] = useState(false)
  const [errData, setErrData] = useState(null as any)
  const [datas, setData] = useState(collectList as any[]);
  const reqMeg = '不能为空'
  useEffect(() => {
    initFn()
  }, [])
  useImperativeHandle(ref, () => ({
    getValue: () => {
      // 验证收款明细是否通过
      const isValid = datas.every(item => item.needVerifiedAmount <= item.unverifiedAmount);
      return {
        isValid,
        details: datas,
        errData,
      };
    },
    validateFields: () => formRef.current?.onFormRef()?.validateFields(),
  }));
  const initFn = async () => {
    if (collectData) {
      setSpinning(true)
      // collectData.receivedClickDate = dayjs(collectData.receivedClickDate)
      collectData.receivedDate = collectData.receivedDate ? dayjs(collectData.receivedDate) : undefined
      collectData.accountingDate = collectData.accountingDate ? dayjs(collectData.accountingDate) : undefined
      formRef.current?.onFormRef()?.setFieldsValue(collectData)
      setSpinning(false)
    } else {
      formRef.current?.onFormRef()?.setFieldsValue({
        customerReceiptFlag: true,
        printType: 'machinePrinting',
      })
    }
  }
  const getOptions = async () => {
    const finAccountLists: any = await finAccountList({
      fmsCompanyCode: financialOrgCode,
      enabled: 1
    })
    finAccountLists.map((item) => {
      item.name = item.accountName + '*' + item.cardNo.slice(-4) // 取cardNo后4位
    })
    // 打印方式
    const printTypeLists: any = await getEnum('com.shj.saas.plus.fms.enums.PrintTypeEnum')
    //支付方式
    const paymentMethodLists: any = await httpDictServTenant({
      parentKey: 'paymentMethod',
      enabled: 1,
    })
    //交易类型
    const transactionFeeTypeLists: any = await httpDictServTenant({
      parentKey: 'transactionFeeType',
      enabled: 1,
    })
    return Promise.resolve({
      // transactionJournalTypeLists,
      finAccountLists,
      printTypeLists,
      paymentMethodLists,
      transactionFeeTypeLists,
    })
  }
  const defaultColumns = [
    { title: '应收单号', dataIndex: 'billNo', width: 140, },
    { title: '收款类型', dataIndex: 'receiptTypeName', width: 120, },
    { title: '应收日期', dataIndex: 'receivableDate', width: 140, },
    { title: '应收金额', dataIndex: 'receivableAmount', width: 120, },
    { title: '未核销金额', dataIndex: 'unverifiedAmount', width: 120, },
    { title: <span>收款金额<span style={{ color: 'red' }}>*</span></span>, dataIndex: 'needVerifiedAmount', width: 140, editable: true, },
  ];
  const columns = defaultColumns.map((col: any) => {
    if (!col.editable) {
      return col;
    }
    return {
      ...col,
      onCell: (record: any) => ({
        record,
        editable: col.editable,
        dataIndex: col.dataIndex,
        title: col.title,
        handleSave,
        errSave,
      }),
    };
  });
  const errSave = (info: any) => {
    setErrData(info)
  }
  const handleSave = (row: any) => {
    const newData = [...datas];
    const index = newData.findIndex((item) => row.id === item.id);
    const item = newData[index];
    newData.splice(index, 1, {
      ...item,
      ...row,
    });
    // 计算 Amount 的合计
    const totalAmount = newData.reduce((total, item) => total + ((item.needVerifiedAmount) || 0), 0);
    formRef.current?.onFormRef()?.setFieldsValue({
      amount: totalAmount,
    })
    setData(newData)
  };
  return (
    <Spin spinning={spinning}>
      <SGeneralForms
        ref={formRef}
        httpOptionsFn={getOptions}
        layout='vertical'
        configs={[
          {
            formItem: [
              { label: 'id', name: 'id', hidden: true },
              {
                label: '收款单号',
                name: 'transactionCode',
                isHideItem: !collectData?.id,
                spanCol: 8,
                comConfig: {
                  disabled: true
                },
              },
              {
                label: '支付方式',
                name: 'paymentMethod',
                spanCol: 8,
                type: 'select',
                data: 'paymentMethodLists',
                required: true,
                rules: [{ required: true, message: reqMeg }],
                comConfig: {
                  fieldNames: { value: 'priKey', label: 'name' },
                },
              },
              {
                label: '收款状态',
                name: 'stateName',
                isHideItem: !collectData?.id,
                spanCol: 8,
                comConfig: {
                  disabled: true
                },
              },
              {
                label: '收款日期',
                name: 'receivedDate',
                type: 'dateTime',
                required: true,
                spanCol: 8,
                rules: [{ required: true, message: reqMeg }],
              },
              {
                label: '收款账户',
                name: 'finAccountId',
                spanCol: 8,
                type: 'select',
                data: 'finAccountLists',
                required: true,
                rules: [{ required: true, message: reqMeg }],
                comConfig: {
                  fieldNames: { value: 'id', label: 'name' },
                },
              },
              {
                label: '付款账户',
                name: 'paymentAccount',
                spanCol: 8,
              },
              {
                label: '收款金额',
                name: 'amount',
                type: 'inputNumber',
                spanCol: 8,
                comConfig: {
                  disabled: true
                },
              },
              {
                label: '收据方式',
                name: 'printType',
                spanCol: 8,
                type: 'select',
                data: 'printTypeLists',
                comConfig: {
                  fieldNames: { value: 'key', label: 'description' },
                },
              },
              {
                label: '收据编号',
                name: 'printNo',
                isDeps: true,
                deps: [{ name: 'printType', value: 'handWriting' }],
                spanCol: 8,
              },
              {
                label: '收据编号',
                name: 'printNo',
                spanCol: 8,
                isHideItem: !collectData?.id,
                comConfig: {
                  disabled: true
                },
              },
              {
                label: '打印状态',
                name: 'printStateName',
                spanCol: 8,
                isHideItem: !collectData?.id,
                comConfig: {
                  disabled: true
                },
              },
              {
                label: '到账日期',
                name: 'accountingDate',
                type: 'dateTime',
                spanCol: 8,
              },
              // {
              //   label: '确认收款时间',
              //   name: 'receivedClickDate',
              //   type: 'dateTime',
              //   spanCol: 8,
              // },
              {
                label: '核销状态',
                name: 'verifyStateName',
                spanCol: 8,
                isHideItem: !collectData?.id,
                comConfig: {
                  disabled: true
                },
              },
              {
                label: '是否客户收款',
                name: 'customerReceiptFlag',
                spanCol: 8,
                type: 'switch',
                checkedChildren: "是",
                unCheckedChildren: "否",
              },
              {
                label: '是否贷款机构转入',
                name: 'creditFlag',
                spanCol: 8,
                type: 'switch',
                checkedChildren: "是",
                unCheckedChildren: "否",
              },
              {
                label: '贷款机构',
                name: 'creditCode',
                isDeps: true,
                deps: [{ name: 'creditFlag', value: true }],
                spanCol: 8,
              },
              {
                label: '备注',
                type: 'textarea',
                name: 'description',
                comConfig: {
                  maxLength: 50,
                },
                spanCol: 24,
              },
            ],
          },
          {
            title: collectList.length > 0 ? '收款明细' : '',
            formItem: collectList.length > 0 ? [ // 仅在 collectList 长度大于 0 时渲染
              {
                name: 'receivedList',
                spanCol: 24,
                children: (
                  <Table
                    components={{
                      body: {
                        row: EditableRow,
                        cell: EditableCell,
                      },
                    }}
                    rowClassName={() => styles.editableRow}
                    rowKey="id"
                    bordered
                    pagination={false}
                    columns={columns}
                    size="small"
                    dataSource={datas} />
                )
              }
            ] : [] // 否则不渲染
          }
        ]}
      />
    </Spin>
  )
})
